import { v4 as uuidV4 } from "uuid";
import Wrapper from "layouts/nms/Wrapper";
function getDummyAlertsWidget(getDataURL, primaryLabel) {
  return {
    primaryLabel,
    secondaryLabel: null,
    getDataURL,
    setDataURL: null,
    apiCode: null,
    hasWebSocketUpdate: null,
    refreshInterval: 120000,
    thresholdLower: null,
    thresholdUpper: null,
    location: null,
    legendField: null,
    valueField: null,
    columns: [
      {
        field: "id",
        heading: "ID",
        type: "number",
        display: false,
      },
      {
        field: "assetId",
        heading: "Asset Id",
        type: "number",
        display: false,
      },
      {
        field: "severity",
        heading: "Severity",
        type: "severity",
        display: true,
      },
      {
        field: "categoryCode",
        heading: "Category",
        type: "string",
        display: true,
      },
      {
        field: "serviceCode",
        heading: "Service",
        type: "string",
        display: true,
      },
      {
        field: "ipAddress",
        heading: "IP Address",
        type: "string",
        display: true,
      },
      {
        field: "nodeName",
        heading: "Name",
        type: "string",
        display: true,
      },
      {
        field: "status",
        heading: "Status",
        type: "boolean",
        display: true,
      },
      {
        field: "alertGeneratedOn",
        heading: "Alert Generated On",
        type: "epoch",
        display: true,
      },
    ],
    actions: null,
    legendFieldDataType: null,
    valueFieldDataType: null,
    widgetType: "table",
    showLegends: null,
    imageName: null,
    width: null,
    height: null,
    category: null,
    min: null,
    max: null,
  };
}

function AlertHistory({ assetId }) {
  return (
    <Wrapper
      key={uuidV4()}
      id="1"
      isAdmin
      username="nkhanna"
      dashboardType="dashboard"
      popupMode
      isSensorsDashboard
      sensorsWidgetList={[
        {
          id: "AssetAlertsHistory",
          data: getDummyAlertsWidget(
            `${process.env.REACT_APP_ASSET_ALERTS_HISTORY_ENDPOINT}${assetId}`,
            "Alert Alerts History",
          ),
        }]}
    />
  );
}

export default AlertHistory;
